import React from "react"
import { BsFacebook, BsLinkedin } from "react-icons/bs"
import { RiInstagramFill } from "react-icons/ri"
import { AiFillTwitterCircle } from "react-icons/ai"

const NewsSocial2 = ({ lang }) => {
  return (
    <section className={`container-main-orange news-social2`}>
      <h1>
        {lang === "en"
          ? "Follow us in our social media"
          : "Síguenos en nuestras redes sociales"}
      </h1>
      <div className="social-dalia">
        <a
          href="https://www.facebook.com/DaliaEmpowerMX"
          target="_blank"
          rel="noreferrer"
        >
          <BsFacebook className="social" />
        </a>
        <a
          href="https://www.instagram.com/daliaempower/"
          target="_blank"
          rel="noreferrer"
        >
          <RiInstagramFill className="social-small" />
        </a>
        <a
          href="https://twitter.com/daliaempower"
          target="_blank"
          rel="noreferrer"
        >
          <AiFillTwitterCircle className="social-small" />
        </a>
        <a
          href="https://www.linkedin.com/company/dalia-empower/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin className="social" />
        </a>
      </div>
    </section>
  )
}

export default NewsSocial2
